<script context="module">
    export function setActiveTab(key, tabs, properties={}) {
        if (Array.isArray(tabs)) {
            let activeTab = tabs.find(t => t.active === true);

            if (activeTab) {
                delete activeTab.active;
            }
            activeTab = tabs.find(t => t.key === key);
            activeTab.active = true
            activeTab.properties = properties

            return [...tabs];
        }
        return tabs;
    }

    export function toggleTabHide(key, hide, tabs) {
        const tab = tabs.find(t => t.key === key);
        if (tab) {
            hide ? tab.hide = true : delete tab.hide;
        }

        return [...tabs];
    }
</script>

<script>

    export let padded = true;
    export let fixedTabs = false;  // set to true to fix the position of the tabs
    export let handleTabChange = (event, activeTab) => {
    };
    export let tabs = [];


    $: selected = tabs.find(t => t.active);

    function onTabClick(event, tab) {
        const activeTab = tabs.find(t => t.active === true);

        if (activeTab) {
            delete activeTab.active;
        }
        tabs.find(t => t.key === tab.key).active = true;

        tabs = [...tabs];
        handleTabChange(event, activeTab);

        // if tab is navigated away from with a tab click, clear focused fields
        if (selected.properties && selected.properties.focus) {
            selected.properties.focus = undefined;
        }
    }

</script>

<style>
    .wrapper {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .tab-content {
        flex: 1;
        height: 100%;
        overflow: auto;
        word-break: break-word;
        background-color: #fff;
        padding-bottom: 100px;
    }

    .padded {
        padding: 30px;
    }

    .fixed-tabs {
        position: fixed;
        width: 100%;
        margin-top: -1px;
        top: 90px;
        left: 0;
        right: 0;
        z-index: 20;
    }
</style>

<div class="wrapper">
    <div class="navbar navbar-expand-lg navbar-light bg-light p-0 nav-tabs"
         class:fixed-tabs={fixedTabs}>
        <ul class="nav nav-tabs mr-auto">
            {#each tabs as tab}
                {#if !tab.hide}
                    <li class="nav-item">
                        <a
                            class="nav-link font-weight-bold"
                            class:active={tab.active}
                            href="#{tab.key}"
                            on:click={event => onTabClick(event, tab)}>
                            {tab.label}
                        </a>
                    </li>
                {/if}
            {/each}
        </ul>
        <slot name="right-nav">
        </slot>
    </div>

    <div class="tab-content" class:padded class:mt-4={fixedTabs}>
        {#if selected}
            {#if typeof selected.content === 'string'}
                {selected.content}
            {:else}
                <svelte:component this={selected.content} {...selected} {...selected.properties}/>
            {/if}
        {/if}
    </div>
</div>
